export { default } from './HotspotsMapContainer';
